import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from './Util/Session/session.service';
import { environment } from '../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PostingOrderService {

  constructor(
    private http: HttpClient,
    private session: SessionService
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  SubContractorDocument(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SubContracter_Posting/Select`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  loadData(details: any) {
    return this.http.post<any>(environment.API_URL + `MasterDocument/Load`,
      this.session.SetClass(details)
    ).pipe(map((response) => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_FillComboOAS(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_FillCombo/OAS`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  PostingOrder(SelectType: any) {
    return this.http.post<any>(environment.API_URL + `PostingOrder_Select/Get`,
      this.session.SetClass(SelectType)
    ).pipe(map(response => {
      return response;
    }));
  }

  ESS_EmployeeSubcontracterSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeSubcontracter/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetDataOnComboLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `GetDataOnCombo/BoxLoad`,
      this.session.SetClass(Detail))
      .pipe(map(response => {
        if (response.Error_Code == '11' || response.Error_Code == '02') {
          this.session.End();
        } else {
          return response;
        }
      }));
  }

  FillCombo(SelectType: any) {
    return this.http.post<any>(environment.API_URL + `DocFillCombo/Load`,
      this.session.SetClass(SelectType)
    ).pipe(map(res => {
      if (res.Error_Code == '11' || res.Error_Code == '02') {
        this.session.End();
      } else {
        return res;
      }
    }));
  }

  PostingOrderInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ALLOTMENTTRANSACTION_INSERT/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      return response;
    }));
  }

  PostingOrderReport(Detail: any) {
    return this.http.post<any>(environment.API_URL + `PostingOrderReport`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      return response;
    }));
  }

}